import type {FieldPolicy} from '@apollo/client';

import {hasMoreFollowUps as hasMoreFollowUpsVar} from '../../query/FollowUpThreads.gql';

/**
 * Implementation of local schema "has more follow up chat threads" field.
 */
export const hasMoreFollowUps: FieldPolicy = {
  read() {
    return hasMoreFollowUpsVar();
  },
};
